import React, { useState,useEffect } from "react";
import axios from "axios";
import { API_URL,RESPONSE_SUCCESS,REQUEST_NOT_FOUND } from './../../GlobalConstents.js';
import { Link, useNavigate,useParams } from "react-router-dom";
import HeaderLayout from "./../../Layout/Header";
import API from './../../Api';
import { toast } from 'react-toastify';
import Loader from "../../Elements/Loader";
import ReactPlayer from 'react-player'
import YouTube, { YouTubeProps } from 'react-youtube';

const VideoView = () => {

    const navigate = useNavigate();

    const { string } = useParams();

    const [records, setRecords] = useState([]); 
    const [isLoading, setIsLoading] = useState(false);
    
    useEffect(
        () => {
        document.body.classList.add('theme-red');
        document.body.classList.remove('login-page');
        document.body.classList.remove('overlay-open');

        LoadVideoInfo()
        
    },[true]); 

    const LoadVideoInfo = async (request) => {

        let objValue =  {"method_name":"videoInfo","video_id":string}

        setIsLoading(true);
        await API.post(API_URL,objValue).then(function (response) {
            setIsLoading(false);
            if (response.status === RESPONSE_SUCCESS) {
                if (response.data.status == "success") {
                    setRecords(response.data.videoInfo);
                } else {
                    toast.error(response.data.message);
                }
            }

        }).catch(function (error) {
           // ForceLogoutUser(error);
        });

    }

    const onReadyVideo = (event) => {
        
        // access to player in all event handlers via event.target
        event.target.pauseVideo();
    }

    let pageTitle = 'Knowledge Section'
    
    return (
        <>
        <HeaderLayout pageTitle={pageTitle} />
        
        <section className="content videoplay">
            <div className="container-fluid">
                <div className="player-wrapper">
                   <ReactPlayer 
                        url={records.video_link}
                        className='react-player'
                        width='100%'
                        height='100%'
                        
                        config={{
                            youtube: {
                                playerVars: { 
                                    showinfo: 1,
                                    modestbranding: 0,
                                    controls:1,
                                },
                            },
                        }}
                    /> 
                    <hr />
                </div>
            </div>
        </section>            
        <section className="content videdetail">
            <div className="container-fluid">            
                <div className="row clearfix">
                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        
                            <div className="header">
                                <h2>
                                    {records.video_title}
                                </h2>
                            </div>
                            <hr/>
                            <div className="body">
                                {records.video_details}
                            </div>
                        
                    </div>
                
                </div>
            </div>
        </section>
        </>
    );
   
}
    
export default VideoView;